// import actions from './actions'
import { getActivateAccountMenuData, getRCLeftMenuData } from 'services/menu'
import _ from 'lodash'
import actionType from '../user/actions'
// import generalActionType from '../general/actions'

const initialState = {
  menuLeftData: [],
  menuTopData: [],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.GET_USER_DATA_SUCCESS_DEPRECATED: {
      return { ...state, menuLeftData: getRCLeftMenuData }
    }
    case actionType.GET_USER_DATA_SUCCESS: {
      let menuLeftData = []
      menuLeftData = _.concat(menuLeftData, getActivateAccountMenuData)
      // const { profile } = action.value
      // const { productPreferences } = profile
      // productPreferences.forEach(product => {
      //   if (product === 'restricted_currencies' || product === 'remittance') {
      //     menuLeftData = _.concat(menuLeftData, getRCLeftMenuData)
      //   }
      //   if (product === 'currency_accounts') {
      //     menuLeftData = _.concat(menuLeftData, getCCLeftMenuData)
      //   }
      // })
      return { ...state, menuLeftData }
    }
    default:
      return state
  }
}
